export default function normaliseText(str) {
  if (!str) return '';
  return str
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .trim(); // Remove leading and trailing spaces
  //    .replace(/[0-9]/g, '') // Remove all numbers
}
